module.exports = __webpack_public_path__ + "img/pocket-7_en.4c15170.jpg";